<div class="page-content">

     <h1 class="page-title" tabindex="0" translate>{{'error.page_title'}}</h1>

     <div translate="error.text1" class="padding-top-2em"></div>
     <div translate="error.text2" class="padding-top-2em"></div>

     <!--
     <div class="btn-div" style="padding-top: 10px;">
          <button class="btn-next" title="{{'error.button.alt_text' | translate}}" 
             (click)="goToStartPage()" translate>
             {{'error.button.label'}}
          </button>
     </div>
     -->
     
</div>
